import { useCallback, useRef, useState } from 'react';

export interface UseIntersectionObserverParams {
  items: string[];
  onChange: (item: string | undefined) => void;
}

const intersectionThreshold = [0.25, 0.5, 0.75, 1];

export const useIntersectionObserver = ({ items, onChange }: UseIntersectionObserverParams) => {
  const [activeItem, setActiveItem] = useState<string>();
  const intersectionValues = useRef<{ [key: string]: number }>({});

  const handleIntersection = useCallback(
    (entry: IntersectionObserverEntry, categoryId: string) => {
      intersectionValues.current[categoryId] = entry.intersectionRatio;

      const current = items.find((item) => intersectionValues.current[item] >= 0.5);

      if (current !== activeItem) {
        setActiveItem(current);
        onChange(current);
      }
    },
    [activeItem, items, onChange],
  );

  return { handleIntersection, intersectionThreshold };
};
